/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DownloadIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path d="M11.5,12.5 L11.5,0.5" />
      <polyline points="7.5 8.5 11.5 12.5 15.5 8.5" />
      <polyline points="6.5 11.5 5.5 11.5 0.5 17.5 23.5 17.5 18.5 11.5 17 11.5" />
      <path d="M20,20.5 L16,20.5" />
      <path d="M0.5,17.5 L0.5,21.5 C0.5,22.6 1.4,23.5 2.5,23.5 L21.5,23.5 C22.6,23.5 23.5,22.6 23.5,21.5 L23.5,17.5" />
    </g>
  </svg>
);

export default DownloadIcon;
